import React from "react";
import { styled } from "styled-components";
import { Chip, Divider, Stack } from "@mui/material";
import {
  MotorcycleSVG,
  PackageSVG,
  ShopBagSVG,
  ShopSVG,
  UsersSVG,
} from "../assets/svg/SvgIcons";
import useFunctions from "../hooks/firebase/useFunctions";
import { useDashboard } from "../hooks/dashboard/useDashboard";
import { numberFormatter } from "../utils/formatter";

const CardTile = ({ data }) => {
  const { title, value, Icon } = data;
  return (
    <TileWrapper className="whiteBg radius8 animate pointer">
      <Stack direction="row" spacing={2.5} alignItems="center">
        <img style={{ width: 40, height: 40 }} src={Icon} alt="svg" />
        <div className="lightBg" style={{ width: 1, height: "60px" }} />
        <div>
          <p className="font13">{title}</p>
          <div className="bold" style={{ fontSize: 25, paddingTop: 5 }}>
            {value}
          </div>
        </div>
      </Stack>
    </TileWrapper>
  );
};

function getCard(title, value, Icon) {
  return { title, value, Icon };
}

export const Dashboard = () => {
  const { TriggerComponent } = useFunctions();
  const { dashboardData } = useDashboard();

  const dashboardTiles = [
    getCard("Orders", numberFormatter(dashboardData?.orders), PackageSVG),
    getCard(
      "Deliveries",
      numberFormatter(dashboardData?.deliveries),
      MotorcycleSVG
    ),
    getCard("Products", numberFormatter(dashboardData?.products), ShopBagSVG),
    getCard("Shops", numberFormatter(dashboardData?.shops), ShopSVG),
    getCard("Customers", numberFormatter(dashboardData?.customers), UsersSVG),
  ];

  return (
    <Stack spacing={3}>
      <Stack spacing={3}>
        <div className="flexNullCenter gap20">
          <h3>Overall Performance</h3>
          <Chip label="Cumulative" />
        </div>
        <GridWrapper>
          {dashboardTiles.map((value, i) => (
            <CardTile key={i} data={value} />
          ))}
        </GridWrapper>
      </Stack>

      <StatsGridWrapper>
        <SectionWrapper>
          <h3>Recent Orders</h3>
          {/* <TriggerComponent /> */}
        </SectionWrapper>
        {/* <SectionWrapper>
          <h3>Product Reviews</h3>
        </SectionWrapper> */}
        <SectionWrapper>
          <h3>Revenue Performance</h3>
        </SectionWrapper>
      </StatsGridWrapper>
    </Stack>
  );
};

const GridWrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, 1fr);

  @media (max-width: 860px) {
    gap: 20px;
    grid-template-columns: 1fr;
  }
`;

const StatsGridWrapper = styled.div`
  display: grid;
  height: calc(100vh - 320px);
  gap: 20px;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 860px) {
    gap: 20px;
    grid-template-columns: 1fr;
  }
`;

const TileWrapper = styled.div`
  padding: 20px 30px;
  &:hover {
    scale: 1.03;
  }
`;

const SectionWrapper = styled.div`
  padding: 20px 30px;
  border-radius: 15px;
  background-color: white;
  transition: all 0.3s ease-in-out;
  &:hover {
    scale: 1.02;
  }
`;
